import { reportPhishing, dontReportPhishing } from '../../strings.locstring.json';
import { phishingDialogTitle, phishingSubText } from './confirmMarkAsPhishing.locstring.json';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import loc from 'owa-localize';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import * as undoActions from 'owa-mail-undo';

/**
 * Helper method to trigger the confirm dialog before processing mark as phishing
 * @param markAsPhishingActionHandler callback after user confirms the mark as phishing action
 */
export default function confirmMarkAsPhishing(markAsPhishingActionHandler: () => void) {
    undoActions.clearLastUndoableAction();

    const reportJunkEmailEnabledByAdmin = getUserConfiguration().SegmentationSettings
        .ReportJunkEmailEnabled;

    // The ReportJunkEmailEnabled parameter specifies whether users can report messages to Microsoft from messages in Outlook on the web.
    // When this parameter is set to false, the Report junk, Report phishing, Report not junk and Unsubscribe options aren't available.
    // Users can stil mark messages as junk, phishing, or not junk, but they won't be able to report messages to Microsoft.
    if (!reportJunkEmailEnabledByAdmin) {
        markAsPhishingActionHandler();
        return Promise.resolve();
    }

    return confirm(loc(phishingDialogTitle), loc(phishingSubText), false /* resolveImmediately */, {
        okText: loc(reportPhishing),
        cancelText: loc(dontReportPhishing),

        // Wait until dialog is dismissed to avoid focus interruption
        delayCallbackAfterAnimation: true,
    }).then((response: DialogResponse) => {
        if (response === DialogResponse.ok) {
            markAsPhishingActionHandler();
        }
    });
}
